module.exports = __webpack_public_path__ + "img/hr-train-stop-ground.b4947a92.png";